import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toDisable'];

  initialize() {
    this.toDisableTargets.forEach((element) => {
      $(element).offon('confirm:complete', (event) => {
        if (event.detail[0]) {
          element.classList.add('disabled-after-confirm');
        }
      });
    });
  }
}
